import Page from '../pages/home.page';
import { mount } from '../mount';
mount(Page);
